import { useMemo } from 'react';
import { CreditCard } from 'Common/utils';

export default function useAvailableIssuers(options) {
    return useMemo(
        () => (options?.EnabledCardTypes ? options.EnabledCardTypes.split(',') : CreditCard.DEFAULT_AVAILABLE),
        [options]
    );
}
